module.exports = __webpack_public_path__ + "img/Fb-research-cn.5a860aad.png";